import { Card, Chip } from '@material-tailwind/react';
import React, { useEffect, useState } from 'react'
import APopover from '../../../components/partials/APopover';
import { useShared } from '../../../hooks/useShared';
import Pagination from '../../../components/table/Pagination'
import EmptyTable from '../../../components/table/EmptyTable'

const Invoice_TABLE_HEAD = ["#", "شماره", "نوع", "تاریخ ارسال", "شرکت", 'کشور', 'اجناس', "حالت اينوايس", 'تاریخ'];

export default function UserInvoiceTable({ v }) {
    const { http, com } = useShared();
    const [loading, setLoading] = useState(false)
    const [invoices, setInvoices] = useState([])


    const getInvoices = (page = 1, data) => {
        if (v.company_id > 0) {
            setLoading(true)
            http.post(`api/invoicesAdvanceSearch?page=${page}`, data).then(res => {
                console.log('ViewUser get user data ', res);
                if (res.data.success && res.data.data) {
                    const data = res.data.data;
                    setInvoices(data)
                }
                setLoading(false)
            }, err => {
                console.log('err');
                setLoading(false)
            })
        }
    }
    useEffect(() => {
        getInvoices(1, { sCompany: { value: v.company_id } })
    }, [])
    const getTariffTableData = () => {
        const data = invoices.data
        return (<tbody className=''>
            {data?.map((r, i) => {
                return (
                    <tr key={i}>
                        <td >{invoices.from + i}</td>
                        <td>{r?.invoice_number}</td>
                        <td>{r?.invoice_type?.label}</td>
                        <td >{com.dateConvert(r?.shipping_date, false)}</td>
                        <td>
                            {r?.invoice_type?.value === 1 ?
                                <> <span>{r?.company?.name_af}</span>   <APopover v={{ data: shippingPopup(r), className: "mt-3", btn: '!bg-green-900/30', iconCss: '!text-green-900' }} /> </> :
                                <><span>{r?.shipping_state?.label}</span>    <APopover v={{ data: shippingPopup(r, false), className: "mt-3", btn: '!bg-green-900/30', iconCss: '!text-green-900' }} /></>}

                        </td>
                        <td >
                            {r?.invoice_type?.value === 1 ?
                                <><span>{r?.shipping_state?.label}</span>    <APopover v={{ data: shippingPopup(r, false), className: "mt-3", btn: '!bg-blue-900/30', iconCss: '!text-blue-900' }} /></> :
                                <> <span>{r?.company?.name_af}</span>   <APopover v={{ data: shippingPopup(r), className: "mt-3", btn: '!bg-blue-900/30', iconCss: '!text-blue-900' }} /> </>
                            }

                        </td>

                        <td style={{ direction: 'rtl' }}>
                            {r?.tariff?.items?.map((item, j) => {
                                return <span key={j} className='ml-1'>{item?.category.label}{j < r?.tariff?.items?.length - 1 && <span >،</span>} </span>
                            })}
                            <APopover v={{ data: itemsPopup(r?.tariff?.items), className: "mt-3" }} />
                        </td>
                        <td> <Chip className='capitalize text-center px-1' variant="ghost" size="sm" color={r.status === 0 && r.attachments?.length === 0 ? 'gray'
                            : r.status === 1 ? 'orange'
                                : r.status === 2 ? 'green' : 'red'}
                            value={r.status === 0 && r.attachments?.length === 0 ? 'Upload Signed Invoice'
                                : r.status === 1 ? 'Pending Aproval'
                                    : r.status === 2 ? 'Completed'
                                        : 'Rejected'} /> </td>

                        <td >{com.dateConvert(r?.created_at, false, true)}
                            <p>{r?.user?.full_name}</p>
                        </td>
                    </tr>
                )
            })}
        </tbody>)
    }



    const itemsPopup = (items) => <table className=" gTable  ">
        <thead >
            <tr className='!bg-deep-purple-900/20 !text-deep-purple-500'>
                <th>#</th>
                <th>جنس</th>
                <th>کميت مترمربع</th>
                <th>قيمت مترمربع</th>
                <th >مقدار کل</th>
            </tr>
        </thead>
        <tbody >
            {items?.map((item, i) => (
                <tr key={i + 1}>
                    <td>{1 + i}</td>
                    <td>{item?.category?.label} </td>
                    <td> {item?.quantity} </td>
                    <td> {item?.price_per_unit}  ؋</td>
                    <td> {item?.quantity * item?.price_per_unit} ؋</td>
                </tr>
            ))}
        </tbody>
    </table>

    const shippingPopup = (r, flag = true) =>
        <> {flag ?

            <table className=" gTable  ">
                <tbody>
                    <tr className='!bg-deep-purple-900/20 !text-deep-purple-500'><th colSpan={2}>شرکت</th></tr>
                    <tr><th>نام</th><td>{r?.company?.name_af}</td></tr>
                    <tr><th>اردرس</th><td>{r?.company?.address}</td></tr>
                    <tr><th>شماره TIN </th><td>{r?.company?.tin_number}</td></tr>
                    <tr><th>شماره جواز </th><td>{r?.company?.license_number}</td></tr>
                    <tr><th>مالک</th><td>{r?.company?.owner?.label}</td></tr>
                    <tr><th>ايميل</th><td>{r?.company?.email}</td></tr>
                </tbody>
            </table> : <table className=" gTable  ">
                <tbody>
                    <tr className='!bg-deep-purple-900/20 !text-deep-purple-500'><th colSpan={2}>ارسال به</th></tr>
                    <tr><th>نام مشتری</th><td>{r?.shipping_name}</td></tr>
                    <tr><th>ادرس</th><td>{r?.shipping_address}</td></tr>
                    <tr><th>شهر</th><td>{r?.shipping_city}</td></tr>
                    <tr><th>کشور</th><td>{r?.shipping_state?.name} - {r?.shipping_state?.label}</td></tr>
                    <tr><th>شماره تماس</th><td>{r?.shipping_phone}</td></tr>
                    <tr><th>ايميل</th><td>{r?.shipping_email}</td></tr>
                </tbody>
            </table>

        }

        </>

    return (
        <Card className="p-2 md:p-4 mt-4 relative">
            <div className='text-main-color font-bold border-b mb-2'>Invoices</div>
            <div className={`overflow-auto grid grid-cols-1 content-between`}>
                <table className="gTable ">
                    <thead className='whitespace-nowrap'>
                        <tr className='!bg-purple-500 '>
                            {Invoice_TABLE_HEAD?.map((head, i) => (
                                <th key={head} className={`${head === "Description" && 'w-[20%]'} px-2`}> {head}</th>
                            ))}
                        </tr>
                    </thead>
                    {getTariffTableData()}
                </table>
                <EmptyTable value={{ loading: loading, length: invoices?.data?.length }} />
                {invoices && <Pagination value={{ getFun: getInvoices, data: invoices }} />}

            </div>
        </Card>
    )
}
